// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"c3771ff6","427":"2aa7ccd0","699":"54562947","833":"5dc11986","882":"f64cbdea","891":"9d6cadb1"}[chunkId] + ".chunk.js";
};